// extracted by mini-css-extract-plugin
module.exports = {"loading":"Home_loading__1PGne","loading-image":"Home_loading-image__1TM3v"};